import { useState } from 'react'
import DataTable from '../../../../../@Common/DataTable'
import NoRows from '../../../../../@Common/DataTable/NoRows'
import { Tooltip } from '@mui/material'
import moment from 'moment-timezone';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { getGridStringOperators, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid';

const localTz = moment.tz.guess()
function CustomToolbar() {
    return (
        <GridToolbarContainer sx={{ padding: '4px 4px 4px' }}>
            <GridToolbarFilterButton />
            <GridToolbarExport />
        </GridToolbarContainer>
    );
}

function InvoiceDataTable({ invoiceItems }) {
    const [filters, setFilters] = useState({
        items: [
        ],
        logicOperator: 'and',
    })
    const columns = [
        {
            field: 'orderDate',
            headerName: 'Date',
            flex: 1,
            type: 'date',
            valueGetter: (params) => params.row.orderDate ? new Date(moment(params.row.orderDate).format('MM/DD/YYYY')) : null,
            renderCell: (params) => params.row.orderDate ? (
                <Tooltip title={
                    <>
                        {moment.utc(params.row.orderDate).format('MM/DD/YYYY hh:mm:ss A z')}
                        <br />
                        {moment(params.row.orderDate).tz(localTz).format('MM/DD/YYYY hh:mm:ss A z')}
                    </>
                } arrow>
                    <span>{moment(params.row.orderDate).format('M/D')}</span>
                </Tooltip>
            ) : null,

        },
        {
            field: 'orderNumber',
            headerName: 'Order Number',
            filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains'),
            flex: 1,
            numeric: true,
        },
        {
            field: 'discountCode',
            headerName: 'Discount Code',
            filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains'),
            flex: 1,
        },
        {
            field: 'orderTotal',
            headerName: 'Order Subtotal',
            numeric: true,
            filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains'),
            valueGetter: (params) => parseFloat(params.row.orderTotal?.toFixed(2)),
            renderCell: (params) => `$${params.value?.toFixed(2)}`,
            flex: 1,
        },
        {
            field: 'commissionRate',
            headerName: 'Commission %',
            flex: 1,
            numeric: true,
            filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains'),
            valueGetter: (params) => params.row.commissionRate * 100,
            renderCell: (params) => `${params.value}%`
        },
        {
            field: 'commissionTotal',
            headerName: 'Commission',
            flex: 1,
            numeric: true,
            filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains'),
            valueGetter: (params) => parseFloat(params.row.commissionTotal?.toFixed(2)),
            renderCell: (params) => `$${params.row.commissionTotal?.toFixed(2)}`,

        }
    ]

    return (
        <DataTable
            noRowsOverlay={<NoRows message={'There are no invoice items for this invoice.'} />}
            customToolbar={<CustomToolbar />}
            additionalCustomSlots={{
                exportIcon: FileDownloadIcon
            }}
            disableExport={false}
            hideFooterWhenNoRows={true}
            getRowId={(row) => row.orderNumber}
            pagination={true}
            hideFooterSelectedRowCount
            rowSelection
            rowCount={invoiceItems ? invoiceItems.length : 0}
            rows={invoiceItems ? invoiceItems : []}
            pageSizeOptions={[25, 50, 100, 500]}
            columns={columns}
            rowsPerPageOptions={[25, 50, 100, 500]}
            disableRowSelectionOnClick
            filterModel={{
                items: filters.items,
                logicOperator: filters.logicOperator,
            }}
            onFilterModelChange={(model) => {
                setFilters({
                    items: model.items,
                    logicOperator: model.logicOperator,
                })
            }}
        />
    )
}

InvoiceDataTable.propTypes = {
}

export default InvoiceDataTable
